import config from '@/config'

/**
 * Check if the current window is inside an iframe
 * @returns {boolean}
 */
export const isEmbedded = () => {
  return window.top !== window.self
}

/**
 * Get the data from iframe name
 * @returns {any}
 */
export const getDataFromIframeName = () => {
  try {
    return JSON.parse(window.name)
  } catch (e) {
    return null
  }
}

/**
 * Get parent origin from iframe data
 * @returns {string|null}
 */
export const getParentOrigin = () => {
  const data = getDataFromIframeName()
  return data?.origin || null
}

const ALLOWED_ORIGIN_REGEXS = [
  /^https:\/\/.*\.ahaslides?\.com$/,
]

/**
 * Check if origin is allowed
 * @param {string} origin
 * @returns {boolean}
 */
export const isAllowedOrigin = (origin) => {
  if (config.env === 'local') return true
  if (!origin) return false

  return ALLOWED_ORIGIN_REGEXS.some((regex) => regex.test(origin))
}

/**
 * Post message to parent iframe if origin is allowed
 * @param {any} message
 */
export const postMessage = (message) => {
  const origin = getParentOrigin()
  if (window.parent && isAllowedOrigin(origin)) {
    window.parent.postMessage(message, origin)
  }
}

/**
 * Post message logout
 */
export const onLogout = () => {
  postMessage({
    type: 'logout',
  })
}

export default {
  isEmbedded,
  getDataFromIframeName,
  getParentOrigin,
  isAllowedOrigin,
  postMessage,
  onLogout,
}
